import {
  json,
  type ActionFunctionArgs,
  type LoaderFunctionArgs,
  redirect,
  type LinksFunction,
  type MetaFunction,
} from "@remix-run/node"
import { Link, useActionData, useSearchParams } from "@remix-run/react"
import { withZod } from "@remix-validated-form/with-zod"
import { ValidatedForm, validationError } from "remix-validated-form"
import { z } from "zod"
import { FormInput, FormSelect, SubmitButton } from "~/components/form-fields"
import Typography from "~/components/typography"
import { Button } from "~/components/ui/button"
import { Public } from "~/utils/remix"
import { commitUserSession, createSession, register } from "~/utils/session.server"
import { EventType, TrackEvent } from "~/models/events.server"
import { HeardAboutUs } from "~/utils/data"

export const meta: MetaFunction = () => {
  return [
    { title: "MakeLoveNotPorn - sign up to enjoy real world sex videos" },
    { property: "og:title", content: "MakeLoveNotPorn - sign up to enjoy real world sex videos" },
    {
      name: "description",
      content:
        "Ready to see what everybody else is really doing in bed? Sign up here for free to delve into the silly, loving real world sex available on MakeLoveNotPorn.",
    },
  ]
}

const validator = withZod(
  z.object({
    UserName: z.string().min(1, { message: "Username is required" }),
    Email: z.string().email({ message: "Invalid email format" }).min(1, { message: "Email is required" }),
    Password: z.string().min(1, { message: "Password is required" }),
    HeardAboutUs: z.string().min(1, { message: "Heard about us is required" }),
    redirectTo: z.string().optional(),
  })
)

export const action = Public(async ({ request, context }: ActionFunctionArgs) => {
  const form = await validator.validate(await request.formData())
  if (form.error) {
    context.logger.warn(`Registration validation errors`, { form: form.data, error: form.error })
    return validationError(form.error)
  }

  const { user, errors } = await register(context, form.data.UserName, form.data.Email, form.data.Password)
  if (errors) {
    context.logger.warn(`Registration failed for ${form.data.UserName}`, { username: form.data.UserName, errors })

    return json(
      {
        fieldErrors: {
          UserName: errors.errors.username,
          Email: errors.errors.email,
          Password: errors.errors.password,
        },
      },
      { status: errors.status }
    )
  }

  // If we have an invalid HeardAboutUs value, likely a bot. Disable account activation.
  if (!HeardAboutUs.map((x) => x.value).includes(form.data.HeardAboutUs)) {
    context.logger.warn(`Invalid HeardAboutUs value for user ${user.UserID}: ${form.data.HeardAboutUs}`, {
      data: form.data,
    })
    await context.db.users.update({
      where: { UserID: user.UserID },
      data: { Status: 2, FlaggedAsBot: new Date() },
    })
  }

  await context.db.users.update({
    where: { UserID: user.UserID },
    data: { RedirectToAfterActivation: form.data.redirectTo ?? undefined },
  })

  const session = await createSession()
  session.flash("success", {
    title: "We've successfully created your account!",
    message: "Please check your email and verify your email to login.",
    email: form.data.Email,
  })

  context.user = user
  await TrackEvent(context, EventType.Signup, { HeardAboutUs: form.data.HeardAboutUs })

  return redirect("/login", {
    headers: {
      "Set-Cookie": await commitUserSession(session),
    },
  })
})

export const loader = Public(async ({ request, context }: LoaderFunctionArgs) => {
  if (context.user) {
    return redirect("/")
  }

  return json({})
})

export const links: LinksFunction = () => [
  {
    rel: "canonical",
    href: "https://makelovenotporn.tv/register",
  },
]

export default function Register() {
  const actionData = useActionData<typeof action>()
  const [searchParams] = useSearchParams()
  return (
    <>
      <div className="container relative h-screen flex-col items-center justify-center md:grid lg:max-w-none lg:grid-cols-5 lg:px-0">
        <Link
          to={`/login${searchParams.get("redirectTo") ? `?redirectTo=${searchParams.get("redirectTo")}` : ""}`}
          className="absolute right-4 top-4 md:right-8 md:top-8">
          <Button>Login</Button>
        </Link>
        <div className="relative hidden h-full flex-col bg-muted p-10 text-white lg:flex lg:col-span-3 dark:border-r">
          <div className="absolute inset-0 bg-zinc-900" />
          <div className="pl-8 pr-8 relative z-20 w-full h-full flex flex-col justify-center items-left">
            <Typography className="subpixel-antialiased text-zinc-200">
              <h1 className="text-4xl font-extralight tracking-tight text-pretty text-zinc-200 ">
                Ready to see what everybody else, all around the world, is <i className="font-black">really</i> doing in
                bed?
              </h1>
              <div className="p-4 font-thin tracking-wider text-xl text-pretty">
                <p>
                  <b>1.</b> &nbsp;&nbsp;Sign up for free
                </p>
                <p>
                  <b>2.</b> &nbsp;&nbsp;Browse thousands of videos, with new uploads every day
                </p>
                <p>
                  <b>3.</b> &nbsp;&nbsp;Subscribe or buy credits to rent and be inspired by #RealWorldSex
                </p>
                <p>
                  <b>4.</b> &nbsp;&nbsp;Reward MakeLoveNotPornstars who get half of each rental
                </p>
              </div>
            </Typography>
          </div>
        </div>
        <div className="lg:p-8 lg:h-screen flex justify-center lg:col-span-2">
          <div className="mx-auto flex w-full flex-col justify-center space-y-1 lg:space-y-6 sm:w-[350px]">
            <div className="flex flex-col space-y-2 text-center lg:hidden mt-20">
              <h1 className="text-md font-semibold tracking-tight">
                Ready to see what everybody else, all around the world, is <i className="font-black">really</i> doing in
                bed?
              </h1>
              <div className="p-2 pl-4 tracking-wider text-xs text-pretty flex flex-col gap-1 text-left">
                <p>
                  <b>1.</b> &nbsp;&nbsp;Sign up for free
                </p>
                <p>
                  <b>2.</b> &nbsp;&nbsp;Browse thousands of videos, with new uploads every day
                </p>
                <p>
                  <b>3.</b> &nbsp;&nbsp;Subscribe or buy credits to rent and be inspired by #RealWorldSex
                </p>
                <p>
                  <b>4.</b> &nbsp;&nbsp;Reward MakeLoveNotPornstars who get half of each rental
                </p>
              </div>
              <h1 className="text-md font-semibold tracking-tight">Create Your Account</h1>
            </div>
            <div className="space-y-2 text-center hidden lg:flex lg:flex-col">
              <h1 className="text-2xl font-semibold tracking-tight">Create an account</h1>
              <p className="text-sm text-muted-foreground">Enter your information below to sign in</p>
            </div>
            <ValidatedForm validator={validator} method="post">
              <input
                type="hidden"
                name="redirectTo"
                value={searchParams.get("redirectTo") ? searchParams.get("redirectTo")! : undefined}
              />
              <div className="grid gap-4">
                <FormInput type="text" name="UserName" label="Username" />
                <FormInput type="email" name="Email" label="Email Address" />
                <FormInput type="password" name="Password" label="Password" inputClasses="mb-2" />
                <FormSelect
                  name="HeardAboutUs"
                  label="How did you hear about us?"
                  placeholder="Select an option"
                  options={HeardAboutUs}
                />
                <SubmitButton content="Let’s do this!" loading="Doing it..." />
              </div>
            </ValidatedForm>
            <Typography className="px-8 text-center text-sm text-muted-foreground">
              By creating an account, you agree to our <Link to="/terms-of-service-agreement">Terms of Service</Link>{" "}
              and <Link to="/privacy-policy">Privacy Policy</Link>.
            </Typography>
          </div>
        </div>
      </div>
    </>
  )
}
